import React, { useState, useEffect } from 'react';
import './InfoPopup.css';
import { getEarlyCheckinDiscounts } from 'src/api/API';

interface Discount {
  name: string;
  value: number;
  type: string;
}

interface InfoPopupProps {
  isOpen: boolean;
  onClose: () => void;
  emailAddress: string;
  cancelBeforeHours: number;
  cancelPenaltyCoins: number;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ isOpen, onClose, emailAddress, cancelBeforeHours, cancelPenaltyCoins }) => {
  const [discounts, setDiscounts] = useState<Discount[]>([]);

  useEffect(() => {
    if (isOpen) {
      fetchDiscounts();
    }
  }, [isOpen]);

  const fetchDiscounts = async () => {
    try {
      const response = await getEarlyCheckinDiscounts();
      setDiscounts(response);
    } catch (error) {
      console.error('Error fetching discounts:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="info-popup-overlay" onClick={onClose}>
      <div className="info-popup" onClick={e => e.stopPropagation()}>
        <div className="info-popup-content">
          <h3>Early check-in discounts per class</h3>
          <ul className="discount-list">
            {discounts.map((discount, index) => (
              <li key={index} className="discount-item">
                {discount.name}: Ȼ {Math.floor(discount.value)}
              </li>
            ))}
          </ul>
          <div className="cancellation-policy">
            Cancellation policy: Class check-ins can be canceled up to {cancelBeforeHours} hours before the class. The cancellation fee is {cancelPenaltyCoins} coins.
          </div>
        </div>
        <button className="info-popup-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default InfoPopup;
